import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import api from "../services/api";

const DiscussionForum = () => {
  const [state, setState] = useState("Bihar");
  const [discussions, setDiscussions] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [loading, setLoading] = useState(false);

  const states = [
    "Bihar",
    "Uttar Pradesh",
    "Maharashtra",
    "Karnataka",
    "Delhi",
    "West Bengal",
    "Punjab",
    "Telangana",
  ];

  useEffect(() => {
    const fetchDiscussions = async () => {
      try {
        const res = await api.get(`/forum?state=${encodeURIComponent(state)}`);
        setDiscussions(res.data || []);
      } catch (err) {
        console.error("Failed to fetch discussions");
      }
    };
    fetchDiscussions();
  }, [state]);

  const handlePost = async () => {
    if (!newComment.trim()) return;
    setLoading(true);
    try {
      const res = await api.post("/forum/post", { state, content: newComment });
      setDiscussions([res.data, ...discussions]);
      setNewComment("");
    } catch (err) {
      console.error("Failed to post comment");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-50 min-h-screen py-10 px-4">
      <div className="max-w-4xl mx-auto">
        <motion.h1
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-4xl font-bold text-indigo-700 text-center"
        >
          💬 Public Forum
        </motion.h1>
        <p className="text-center text-sm text-gray-500 mt-1 italic mb-6">
          "Yahan awaaz milti hai awaazon se — chalo mil baith ke baat karein."
        </p>

        <div className="flex justify-between items-center bg-white p-4 rounded shadow mb-6">
          <label className="text-gray-700 font-semibold">State:</label>
          <select
            value={state}
            onChange={(e) => setState(e.target.value)}
            className="px-3 py-2 border rounded"
          >
            {states.map((s) => (
              <option key={s}>{s}</option>
            ))}
          </select>
        </div>

        <div className="bg-white p-4 rounded shadow mb-6">
          <textarea
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            rows={3}
            className="w-full border p-3 rounded"
            placeholder="Kya dikkat hai aapke area mein?"
          ></textarea>
          <button
            onClick={handlePost}
            disabled={loading}
            className="mt-2 bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded shadow"
          >
            {loading ? "Posting..." : "Post Discussion"}
          </button>
        </div>

        <div className="space-y-4">
          {discussions.map((post, idx) => (
            <div key={idx} className="bg-white border p-4 rounded shadow hover:shadow-md">
              <p className="text-gray-800 font-medium">{post.content}</p>
              <div className="text-sm text-gray-500 mt-1">
                🌐 {post.state} &middot; Upvotes: {post.upvotes || 0}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DiscussionForum;
